import { loggedOutPromoOnboardingWaitlist } from 'src/app/router/paths';

import { PromoPageLink } from './styles';

const errorTextCopy = {
  text: "Capsule doesn't deliver in your area just yet. Try your work ZIP code, or",
  linkText: ' join our waiting list.',
};

export const ErrorLinkText = () => {
  return (
    <>
      {errorTextCopy.text}
      <PromoPageLink to={loggedOutPromoOnboardingWaitlist.toPath()}>{errorTextCopy.linkText}</PromoPageLink>
    </>
  );
};
